<template>
  <div class="new-fundraiser-page">
    <div
      class="sub-header"
      data-test="sub-header"
    >
      Thank you for creating a donor account!
    </div>
    <div
      class="overflow-y-scroll scrollbar modal-height text-base modal-width"
      data-test="welcome-message"
    >
      We’re so glad you’ve joined us! In order to make the most of your Giving Days Experience, we invite you to take a
      moment to tell us a bit more about yourself. By selecting your preferences, we can make sure to prioritize causes
      that matter most to you!
    </div>
  </div>
</template>

<script setup></script>
<style lang="scss">
.modal-height {
  height: 345px;
}
.sub-header {
  font-size: 1.625rem;
  font-weight: 500;
  margin-bottom: 20px;
}

.inputs {
  width: 430px;
}
.modal-width {
  width: 430px;
}

@media screen and (max-width: 768px) {
  .modal-width {
    width: 100%;
  }
  .modal-height {
    height: calc(80vh - 320px);
  }
  .sub-header {
    text-align: center;
  }
  .inputs {
    width: 100%;
  }
}
</style>
